import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const addCoupon = async (token, data) => {
  const url = `${BASE_URL}/coupons/coupon/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllCoupons = async (token, params = {}) => {
  const url = `${BASE_URL}/coupons/coupon/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getCoupon = async (token, couponId) => {
  const url = `${BASE_URL}/coupons/coupon/${couponId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateCoupon = async (token, data, couponId) => {
  const url = `${BASE_URL}/coupons/coupon/${couponId}/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.patch(url, data, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const deleteCoupon = async (token, couponId) => {
  const url = `${BASE_URL}/coupons/coupon/${couponId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};
